type ResolutionMap = Record<number, number>;

/**
 * least-squares-fit
 * Calculate the least square fit linear regression of provided values
 * @param resMap - A map of viewport widths (in pixels) to size values (in pixels)
 * @returns Linear equation as a CSS `calc()` function
 * @example
 * font-size: leastSquaresFit({ 576: 24, 768: 24, 992: 34 });
 */
export const leastSquaresFit = (resMap: ResolutionMap): string => {
    const entries = Object.entries(resMap);

    // Get the number of provided breakpoints
    if (entries.length < 2) return '';

    // Calculate the means
    let resTotal = 0;
    let valueTotal = 0;

    for (const [key, value] of entries) {
        resTotal += Number(key);
        valueTotal += value;
    }

    const resMean = resTotal / entries.length;
    const valueMean = valueTotal / entries.length;

    let multipliedDiff = 0;
    let squareDiff = 0;

    for (const [key, value] of entries) {
        const resDiff = Number(key) - resMean;
        const valueDiff = value - valueMean;

        multipliedDiff += resDiff * valueDiff;
        squareDiff += resDiff * resDiff;
    }

    // Calculate the slope (m) and y-intercept (b)
    const m = multipliedDiff / squareDiff;
    const b = valueMean - m * resMean;

    // Return the CSS calc equation
    return `calc(${m * 100}vw + ${b}px) !important`;
};